/**
 * Welcome Popup — __bxstr_welcome-popup.js
 * Timer, localStorage, native form submit, focus trap.
 * Vanilla JS — no jQuery dependency.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'bxstr_welcome_popup_seen';
  var AUTO_CLOSE_MS = 3000;

  var popup = document.getElementById('bxstr-welcome-popup');
  if (!popup) return;

  var backdrop = document.getElementById('bxstr-welcome-popup-backdrop');
  var closeBtn = popup.querySelector('.bxstr-popup__close');
  var dismissBtn = popup.querySelector('.bxstr-popup__dismiss');
  var form = popup.querySelector('.bxstr-popup__form');
  var emailInput = popup.querySelector('.bxstr-popup__input');
  var errorEl = popup.querySelector('.bxstr-popup__error');
  var formState = popup.querySelector('.bxstr-popup__form-state');
  var successState = popup.querySelector('.bxstr-popup__success');
  var delaySeconds = parseInt(popup.dataset.delay, 10) || 5;
  var mobileExtraDelay = 5;

  /* Detect redirect back from Shopify after successful subscribe */
  var subscribed = new URLSearchParams(location.search).get('popup_subscribed') === '1';

  /* Guard: already seen and not returning from a subscribe redirect */
  if (!subscribed && localStorage.getItem(STORAGE_KEY)) return;

  /* Disable browser native validation — we handle it ourselves */
  form.noValidate = true;

  /* --- Helpers --- */
  function isMobile() {
    return window.innerWidth < 750;
  }

  function markSeen() {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {
      /* Private browsing — silent fail */
    }
  }

  /* --- Open / Close --- */
  var savedOverflow = '';

  function openPopup() {
    savedOverflow = document.body.style.overflow;
    popup.classList.add('bxstr-popup--visible');
    backdrop.classList.add('bxstr-popup--visible');
    document.body.style.overflow = 'hidden';
    trapFocus();
    if (emailInput) emailInput.focus();
  }

  function closePopup() {
    popup.classList.add('bxstr-popup--closing');
    backdrop.classList.remove('bxstr-popup--visible');
    document.body.style.overflow = savedOverflow;
    releaseFocus();

    setTimeout(function () {
      popup.classList.remove('bxstr-popup--visible', 'bxstr-popup--closing');
    }, 150);
  }

  function dismissPopup() {
    markSeen();
    closePopup();
  }

  function showSuccess() {
    markSeen();
    formState.classList.add('bxstr-popup__form-state--hidden');
    successState.classList.add('bxstr-popup__success--visible');
    setTimeout(closePopup, AUTO_CLOSE_MS);
  }

  /* --- Focus trap --- */
  var previouslyFocused = null;

  function getFocusable() {
    return popup.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
  }

  function trapFocus() {
    previouslyFocused = document.activeElement;
    document.addEventListener('keydown', handleTrapKey);
  }

  function releaseFocus() {
    document.removeEventListener('keydown', handleTrapKey);
    if (previouslyFocused) previouslyFocused.focus();
  }

  function handleTrapKey(e) {
    if (e.key === 'Escape') {
      dismissPopup();
      return;
    }
    if (e.key !== 'Tab') return;

    var focusable = getFocusable();
    if (focusable.length === 0) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  /* --- Email validation --- */
  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  /* --- Form submission (native POST) --- */
  function handleSubmit(e) {
    var email = emailInput.value.trim();

    if (!isValidEmail(email)) {
      e.preventDefault();
      emailInput.classList.add('bxstr-popup__input--error');
      errorEl.textContent = errorEl.dataset.invalid || 'Please enter a valid email';
      return;
    }

    /* Send trimmed value and mark seen before the page navigates */
    emailInput.value = email;
    markSeen();
    /* Native form POST proceeds — Shopify handles subscription and redirects back with ?popup_subscribed=1 */
  }

  /* --- Bind events --- */
  closeBtn.addEventListener('click', dismissPopup);
  dismissBtn.addEventListener('click', dismissPopup);
  backdrop.addEventListener('click', dismissPopup);
  form.addEventListener('submit', handleSubmit);

  emailInput.addEventListener('input', function () {
    emailInput.classList.remove('bxstr-popup__input--error');
    errorEl.textContent = '';
  });

  /* --- Entry point --- */
  if (subscribed) {
    /* Coming back from Shopify redirect — clean URL, scroll to top, show success state */
    history.replaceState(null, '', location.pathname);
    window.scrollTo(0, 0);
    openPopup();
    showSuccess();
  } else {
    var delay = delaySeconds * 1000;
    if (isMobile()) {
      delay += mobileExtraDelay * 1000;
    }
    setTimeout(openPopup, delay);
  }
})();
